/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-extraneous-dependencies */
import {
  createRef,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { Link } from "react-router-dom";
import { Card, CardContent, CardDescription } from "@repo/ui";
import { getSelectedState, Grid, GridColumn } from "@progress/kendo-react-grid";
import { getter, process } from "@progress/kendo-data-query";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { PATHS } from "routes/paths";
import Loader from "ui/page-loader";
import { useUser } from "hooks/use-user";
import {
  useExportOpenRequests,
  useGetOpenRequests,
  useMaintenanceBulkAssign,
} from "services/maintenance";
import { BreadCrumb } from "ui/bread-crumbs";
import { FiltersContext } from "store/filters-context";
import TaskFilterBarV2 from "components/tickets/tasks-filter-bar";
import { StatusContext } from "../constants";
import {
  fixKendoGridContent,
  getTicketDetailsPage,
  isFilterUpdated,
} from "../utils";
import GridDataCopyCell from "components/copy";
import SLACell from "../common/SLACell";
import {
  useExportPanicAlertIncidentOpenRequests,
  useGetPanicAlertIncidentOpenRequests,
  usePanicAlertIncidentBulkAssign,
} from "services/panic-alert";
import { getSlaStageStyle } from "../common/sla-utils";
import { SiteAccessibleCell } from "../common/site-accessible-cell";

const CSMonitoringColumns = {
  location: "office",
  assetId: "vehicle",
};
const excludeColumns = ["SLA", "City", "Vault Access"];
const useGetRequests = () => {
  const user = useUser();
  // console.log("user", user);
  const CSMonitoring = useGetPanicAlertIncidentOpenRequests();
  const dispatcherTickets = useGetOpenRequests();
  if (user.Roles.includes("CS Monitoring")) {
    return CSMonitoring;
  }
  return dispatcherTickets;
};
const useExportRequests = () => {
  const user = useUser();
  const panicAlertRequests = useExportPanicAlertIncidentOpenRequests();
  const dispatcherTickets = useExportOpenRequests();
  if (user.Roles.includes("CS Monitoring")) {
    return panicAlertRequests;
  }

  return dispatcherTickets;
};
const useBulkAssign = () => {
  const user = useUser();
  const panicAlertRequests = usePanicAlertIncidentBulkAssign();
  const dispatcherTickets = useMaintenanceBulkAssign();
  if (user.Roles.includes("CS Monitoring")) {
    return panicAlertRequests;
  }

  return dispatcherTickets;
};

export default function DispatcherOpenTicketsList() {
  const [dataState, setDataState] = useState({
    sort: [
      {
        field: "code",
        dir: "asc",
      },
    ],
  });
  const [tickets, setTickets] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedState, setSelectedState] = useState({});
  const { setStatus } = useContext(StatusContext);
  const { filters } = useContext(FiltersContext);
  const [localFilters, setLocalFilters] = useState({
    searchCriteria: filters?.searchCriteria?.value || "",
    period: filters?.period?.value || "All",
    cashCenterId: filters?.cashCenterId?.value || "",
    customerId: filters?.customerId?.value || "",
    assetId: filters?.assetId?.value || "",
    activityType: filters?.activityType?.value || "",
    routeNo: filters?.routeNo?.value || "",
    assignedTo: filters?.assignedTo?.value || "",
    responseSla: filters?.responseSla?.value || "",
    resolutionSla: filters?.resolutionSla?.value || "",
  });

  const user = useUser();
  const pageSize = 100;
  const _exporter = createRef();
  const DATA_ITEM_KEY = "requestId";
  const SELECTED_FIELD = "selected";
  const idGetter = getter(DATA_ITEM_KEY);

  const {
    mutate: getTickets,
    data: ticketsList,
    isPending: gettingTickets,
    reset: resetGetTickets,
  } = useGetRequests();

  const {
    mutate: getAllTickets,
    data: allTicketsData,
    isPending: gettingAllTickets,
    reset: getAllTicketsReset,
  } = useExportRequests();

  const {
    mutate: bulkAssign,
    data: bulkAssignRes,
    isPending: bulkAssigning,
    error: bulkAssignError,
    reset: bulkAssignReset,
  } = useBulkAssign();

  useEffect(() => {
    if (allTicketsData) {
      excelExport();
      getAllTicketsReset();
    }
    if (bulkAssignRes) {
      bulkAssignReset();
    }
    if (bulkAssignError) {
      bulkAssignReset();
    }
  }, [allTicketsData, bulkAssignRes, bulkAssignError]);
  useEffect(() => {
    const nextFilters = {
      searchCriteria: filters?.searchCriteria?.value || "",
      period: filters?.period?.value || "All",
      cashCenterId: filters?.cashCenterId?.value || "",
      customerId: filters?.customerId?.value || "",
      assetId: filters?.assetId?.value || "",
      activityType: filters?.activityType?.value || "",
      routeNo: filters?.routeNo?.value || "",
      assignedTo: filters?.assignedTo?.value || "",
      responseSla: filters?.responseSla?.value || "",
      resolutionSla: filters?.resolutionSla?.value || "",
    };

    if (isFilterUpdated(localFilters, nextFilters)) {
      setLocalFilters({ ...nextFilters });
    }
  }, [filters]);
  useEffect(() => {
    setCurrentPage(1);
    getTickets({
      pageNumber: 1,
      pageRowCount: pageSize,
      ...localFilters,
    });
  }, [localFilters]);

  useEffect(() => {
    if (ticketsList) {
      setTotalRecords(ticketsList.data.totalRecords);
      setTickets(
        ticketsList.data.data.map((elm) => ({
          ...elm,
          selected: false,
          responseSlaStageText: getSlaStageStyle(elm?.responseSla?.slaStage)
            .label,
          resolutionSlaStageText: getSlaStageStyle(elm?.resolutionSla?.slaStage)
            .label,
        })),
      );
      resetGetTickets();
    }
  }, [ticketsList]);

  const onPageChange = (e) => {
    const _page = e.page.skip / pageSize + 1;
    setCurrentPage(_page);
    getTickets({
      pageNumber: _page,
      pageRowCount: pageSize,
      ...localFilters,
    });
  };

  const onRefresh = () => {
    getTickets({
      pageNumber: currentPage,
      pageRowCount: pageSize,
      ...localFilters,
    });
  };

  const excelExport = () => {
    if (_exporter.current) {
      _exporter.current.save();
    }
  };

  const onSelectionChange = useCallback(
    (event) => {
      const newSelectedState = getSelectedState({
        event,
        selectedState,
        dataItemKey: DATA_ITEM_KEY,
      });

      setSelectedState(newSelectedState);
    },
    [selectedState],
  );

  const onHeaderSelectionChange = useCallback((event) => {
    const checkboxElement = event.syntheticEvent.target;
    const checked = checkboxElement.checked;
    const newSelectedState = {};
    if (checked) {
      event.dataItems.forEach((item) => {
        newSelectedState[idGetter(item)] = checked;
      });
    }
    setSelectedState(newSelectedState);
  }, []);

  const onBulkAssign = (information) => {
    const selectedItems = [];
    Object.keys(selectedState).forEach((elm) => {
      if (selectedState[elm]) {
        selectedItems.push(elm);
      }
    });
    const payload = {
      cashCenterId: user.CashCenterId,
      operationDate: new Date(),
      routeNo: information.routeNo,
      dispatcherId: information.dispatcherId,
      assigneeId: information.assigneeId,
      secondaryAssigneeId: information.secondaryAssigneeId,
      requests: selectedItems.map((elm) => ({
        requestId: elm,
      })),
    };
    bulkAssign(payload);
    setSelectedState({});
  };

  const getSelectedRequests = useMemo(() => {
    return tickets.filter((elm) => selectedState[elm.requestId]);
  }, [selectedState]);

  return (
    <div className="box-border">
      {gettingTickets || bulkAssigning ? <Loader /> : <></>}
      <BreadCrumb
        className="mx-4"
        items={[{ text: "Dashboard", to: "/" }, { text: "Open Tickets" }]}
      />
      <Card className="mx-4 mt-5">
        <CardContent>
          <CardDescription className="pt-6">
            <TaskFilterBarV2
              hideAssignmentGroup
              hideStatus
              exportExcel
              bulkUpload
              onRefresh={onRefresh}
              exportingExcel={gettingAllTickets}
              selectedRequests={getSelectedRequests}
              assignTeam={onBulkAssign}
              onExcelExport={() => {
                getAllTickets({
                  status: "All",
                  ...localFilters,
                });
              }}
            />
          </CardDescription>

          <Grid
            data={process(
              tickets.map((item) => ({
                ...item,
                [SELECTED_FIELD]: selectedState[idGetter(item)],
              })),
              dataState,
            )}
            {...dataState}
            onDataStateChange={(e) => {
              e.dataState.skip = 0;
              setDataState(e.dataState);
            }}
            className="list-tables-v1"
            width="100%"
            filterable
            sortable
            pageable
            navigatable
            total={totalRecords}
            pageSize={pageSize}
            skip={(currentPage - 1) * pageSize}
            dataItemKey={DATA_ITEM_KEY}
            selectedField={SELECTED_FIELD}
            onPageChange={onPageChange}
            selectable={{
              enabled: true,
              drag: true,
              cell: false,
              mode: "multiple",
            }}
            onSelectionChange={onSelectionChange}
            onHeaderSelectionChange={onHeaderSelectionChange}
            ref={(e) => {
              fixKendoGridContent(e);
            }}
          >
            <GridColumn
              field={SELECTED_FIELD}
              width="50px"
              filterable={false}
              headerSelectionValue={
                tickets.findIndex((item) => !selectedState[idGetter(item)]) ===
                -1
              }
            />
            <GridColumn
              title="Bank Reference"
              field="customerTicketNo"
              width="150px"
            />
            <GridColumn
              title="TG Reference Number"
              width="170px"
              field="caseNo"
              cell={(items) => {
                const dataItem = items.dataItem;
                return (
                  <GridDataCopyCell
                    dataItem={items.dataItem}
                    field={items.field}
                    customCell={
                      <td>
                        <Link
                          onClick={() => {
                            setStatus("open");
                          }}
                          to={getTicketDetailsPage(dataItem)}
                        >
                          {dataItem.status === "Draft"
                            ? "View Draft"
                            : dataItem.caseNo}
                        </Link>
                      </td>
                    }
                  />
                );
              }}
            />
            <GridColumn
              title="Task Number"
              width="170px"
              field="taskNo"
              cell={(items) => {
                const dataItem = items.dataItem;
                return (
                  <GridDataCopyCell
                    dataItem={items.dataItem}
                    field={items.field}
                    customCell={
                      <td>
                        <Link
                          onClick={() => {
                            setStatus("open");
                          }}
                          to={
                            dataItem.status === "Draft"
                              ? `${PATHS.createTicket}/${dataItem.ticketId}`
                              : `${PATHS.taskDetails}/${dataItem.requestId}`
                          }
                        >
                          {dataItem.status === "Draft"
                            ? "View Draft"
                            : dataItem.taskNo}
                        </Link>
                      </td>
                    }
                  />
                );
              }}
            />
            <GridColumn title="Asset Id" field="locationId" width="150px" />
            <GridColumn
              title="Response SLA"
              field="responseSlaStageText"
              width="150px"
              headerClassName="text-center"
              className="text-center"
              cell={(props) => {
                const stage = props.dataItem?.responseSla?.slaStage;
                const { label, bg } = getSlaStageStyle(stage);

                return (
                  <td>
                    <div className="flex items-center justify-center">
                      {label !== "-" && (
                        <div
                          className="flex px-3 py-1 items-center justify-center text-sm font-medium rounded-md border"
                          style={{
                            width: "120px",
                            backgroundColor: bg,
                            color: bg === "transparent" ? "#374151" : "#fff",
                          }}
                        >
                          {label}
                        </div>
                      )}
                    </div>
                  </td>
                );
              }}
            />

            <GridColumn
              title="Resolution SLA"
              field="resolutionSlaStageText"
              width="160px"
              headerClassName="text-center"
              className="text-center"
              cell={(props) => {
                const stage = props.dataItem?.resolutionSla?.slaStage;
                const { label, bg } = getSlaStageStyle(stage);

                return (
                  <td>
                    <div className="flex items-center justify-center">
                      {label !== "-" && (
                        <div
                          className="flex px-3 py-1 items-center justify-center text-sm font-medium rounded-md border"
                          style={{
                            width: "120px",
                            backgroundColor: bg,
                            color: bg === "transparent" ? "#374151" : "#fff",
                          }}
                        >
                          {label}
                        </div>
                      )}
                    </div>
                  </td>
                );
              }}
            />
            <GridColumn
              title="Site Accessible"
              field="isSiteAccessible"
              width="150px"
              headerClassName="text-center"
              className="text-center"
              cell={SiteAccessibleCell}
            />
            <GridColumn title="Region" field="region" width="150px" />
            <GridColumn
              title="SLA"
              field="sla"
              headerClassName="text-center"
              width="150px"
              cell={SLACell}
            />
            <GridColumn title="City" field="city" width="150px" />
            <GridColumn title="Location" field="locationName" width="170px" />
            <GridColumn
              title="Activity Type"
              field="serviceType"
              width="170px"
            />
            <GridColumn title="Category" field="fault" width="150px" />
            <GridColumn
              title="Sub Category"
              field="faultDetails"
              width="150px"
            />
            <GridColumn title="Assigned To" field="assigneeId" width="150px" />
            <GridColumn title="Route No" field="routeNo" width="120px" />
            <GridColumn
              title="Secondary Assignee"
              field="secondaryAssigneeId"
              width="220px"
            />
            <GridColumn
              title="Created At"
              field="createDateTime"
              width="120px"
              className="text-center"
              headerClassName="text-center"
            />
            {/* <GridColumn
              title="Started At"
              field="startedDateTime"
              width="120px"
              className="text-center"
              headerClassName="text-center"
            />
            <GridColumn
              title="Ended At"
              field="resolvedDateTime"
              width="120px"
              className="text-center"
              headerClassName="text-center"
            /> */}
            <GridColumn title="Account" field="customer" width="170px" />
            <GridColumn
              title="Vault Access"
              field="vaultAccessRequired"
              width="170px"
            />
            <GridColumn
              title="State"
              field="status"
              width="150px"
              className="text-center"
              headerClassName="text-center"
              filterable
            />
            <GridColumn
              title="Assignment Group"
              field="assignmentGroup"
              width="170px"
            />
            <GridColumn
              title="Description"
              field="remarks"
              width="400px"
              cell={GridDataCopyCell}
            />
            <GridColumn
              title="Resolution Notes"
              field="resolutionNotes"
              width="170px"
              cell={GridDataCopyCell}
            />
          </Grid>
          <ExcelExport
            data={allTicketsData?.data.data || []}
            fileName="Tickets.xlsx"
            ref={_exporter}
          >
            <GridColumn title="Bank Reference No" field="customerTicketNo" />
            <GridColumn title="Ticket Number" width="170px" field="caseNo" />
            <GridColumn title="Task Number" field="taskNo" width="170px" />
            <GridColumn title="Asset Id" field="locationId" width="150px" />
            <GridColumn title="Region" field="region" width="150px" />
            <GridColumn title="Location" field="locationName" width="170px" />
            <GridColumn
              title="Activity Type"
              field="serviceType"
              width="170px"
            />
            <GridColumn title="Category" field="fault" width="150px" />
            <GridColumn
              title="Sub Category"
              field="faultDetails"
              width="150px"
            />
            <GridColumn title="Assigned To" field="assigneeId" />
            <GridColumn title="Route No" field="routeNo" />
            <GridColumn
              title="Secondary Assignee"
              field="secondaryAssigneeId"
            />
            <GridColumn
              title="Vault Access"
              field="vaultAccessRequired"
              width="150px"
            />
            <GridColumn
              title="Created At"
              field="createDateTime"
              width="170px"
            />
            <GridColumn title="State" field="status" width="200px" />
            <GridColumn title="Account" field="customer" width="170px" />
            <GridColumn
              title="Vault Access Required"
              field="vaultAccessRequired"
              width="170px"
            />
            <GridColumn
              title="Assignment Group"
              field="assignmentGroup"
              width="170px"
            />
            <GridColumn title="Description" field="remarks" width="170px" />
            <GridColumn
              title="Resolution Notes"
              field="resolutionNotes"
              width="170px"
            />
            <GridColumn title="Opened By" field="openedBy" width="170px" />
          </ExcelExport>
        </CardContent>
      </Card>
    </div>
  );
}
